// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ko-1";
export var messageSideRight = "_ko-2";
export var subscribeToBackInStockBubbleContainer = "_ko-0";